import { Box, type BoxProps } from './Box';

export type StackProps = Omit<BoxProps, 'display' | 'flexDirection'>;

export function Stack({ gap = 8, ...rest }: StackProps) {
    return <Box display="flex" flexDirection="column" gap={gap} {...rest} />;
}
